module.exports = __webpack_public_path__ + "img/queue-upgrade.fe1f2aed.svg";